'use strict';

(function () {
    angular
        .module('tracking')
        .component('discrepancyListComponent', {
            templateUrl: 'tracking/components/discrepancy-list-component.tpl.html',
            controller: function ($timeout, $scope, applicationConstants, trackingConstants,MessageService) {
                var vm = this;
                vm.selectedDiscrepancy = null;
                vm.selectedSubDiscrepancies = {};

                vm.$onChanges = function (changeObj) {
                    if (changeObj.discrepancies && changeObj.discrepancies.currentValue && (changeObj.discrepancies.currentValue != changeObj.discrepancies.previousValue)) {
                        if (vm.discrepancies.length > 0) {
                            setSelectedDiscrepancy(vm.discrepancies[0]);
                            angular.forEach(vm.discrepancies,function (discrepancy) {
                                makeSubDiscrepancySelected(discrepancy);
                            });
                        }
                    }
                };

                vm.onDiscrepancyClick = function (discrepancy) {
                    setSelectedDiscrepancy(discrepancy);
                    makeSubDiscrepancySelected(discrepancy);
                };

                vm.onSubTypeClick = function (discrepancy, subType, event) {

                    var isTypeEmpty = function (type) {
                        var selection = vm.selectedSubDiscrepancies[type];
                        var selectionCount = 0;
                        angular.forEach(Object.keys(selection), function (lbl) {
                            if (selection[lbl]) {
                                selectionCount++;
                            }
                        });
                        return selectionCount > 0 ? false : true;
                    };

                    var showWarning = function (type) {
                        var msg = {
                            'OPEN_PAIR' :  MessageService.MESSAGES.TRACKING.DISCREPANCY_CREW_TYPE_SELECTION_CONSTRAIN,
                            'LANG_WARNING' : MessageService.MESSAGES.TRACKING.DISCREPANCY_LANG_TYPE_SELECTION_CONSTRAIN
                        }
                        if(!!msg[type]){
                            MessageService.warning(msg[type]);
                        }
                    };

                    if (discrepancy == vm.selectedDiscrepancy) {
                        vm.selectedSubDiscrepancies[discrepancy.type][subType] = !vm.selectedSubDiscrepancies[discrepancy.type][subType];

                        if (discrepancy.type == trackingConstants.DESCRIPANCY_TYPES.OPEN_PAIR ||
                            discrepancy.type == trackingConstants.DESCRIPANCY_TYPES.LANG_WARNING
                        ) {
                            if(isTypeEmpty(discrepancy.type)){
                                vm.selectedSubDiscrepancies[discrepancy.type][subType] = !vm.selectedSubDiscrepancies[discrepancy.type][subType];
                                showWarning(discrepancy.type);
                            }else{
                                callDiscrepancySelectedCallback();
                            }
                        } else {
                            callDiscrepancySelectedCallback();
                        }

                    } else {
                        setSelectedDiscrepancy(discrepancy);
                    }
                    event.preventDefault();
                    event.stopPropagation();
                };

                function callDiscrepancySelectedCallback () {
                    vm.onDiscrepancySelected(
                        {
                            discrepancy: vm.selectedDiscrepancy,
                            subTypes: vm.selectedSubDiscrepancies
                        });
                }

                function setSelectedDiscrepancy(discrepancy) {
                    vm.selectedDiscrepancy = discrepancy;
                    makeSubDiscrepancySelected(discrepancy);
                    callDiscrepancySelectedCallback();
                }

                function makeSubDiscrepancySelected(discrepancy) {
                    if (discrepancy.messages.length > 0) {
                        vm.selectedSubDiscrepancies[discrepancy.type] = {};
                        angular.forEach(discrepancy.messages, function (msgObj) {
                            vm.selectedSubDiscrepancies[discrepancy.type][msgObj.type] = true;
                        });
                    }
                }

            },
            bindings: {
                discrepancies: '<',
                onDiscrepancySelected: '&'
            }
        });
})();
